import macro from '../../../macros.js';

function vtkManipulatorMixin(publicAPI, model) {
  publicAPI.updateManipulator = function () {
    if (model.manipulator) {
      var origin = model.origin,
          normal = model.normal,
          direction = model.direction;
      var _model$manipulator = model.manipulator,
          setHandleOrigin = _model$manipulator.setHandleOrigin,
          setHandleCenter = _model$manipulator.setHandleCenter,
          setHandleNormal = _model$manipulator.setHandleNormal,
          setHandleDirection = _model$manipulator.setHandleDirection;

      if (origin && setHandleOrigin) {
        setHandleOrigin(origin);
      } else if (origin && setHandleCenter) {
        setHandleCenter(origin);
      }

      if (direction && setHandleDirection) {
        setHandleDirection(direction);
      } else if (direction && !normal && setHandleNormal) {
        setHandleNormal(direction);
      } else if (normal && setHandleDirection) {
        setHandleDirection(normal);
      }
    }
  };
} // ----------------------------------------------------------------------------


var DEFAULT_VALUES = {
  manipulator: null
}; // ----------------------------------------------------------------------------

function extend(publicAPI, model) {
  var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.assign(model, DEFAULT_VALUES, initialValues);
  macro.setGet(publicAPI, model, ['manipulator']);
  vtkManipulatorMixin(publicAPI, model);
} // ----------------------------------------------------------------------------

var manipulator = {
  extend: extend
};

export { manipulator as default, extend };
